import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useContext, useRouter } from '@nuxtjs/composition-api';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLeftSidebar',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('lg');
const { route } = useContext();
const router = useRouter();

const sidebarMenu = computed(() =>
  props.data?.menu?.filter(
    ({ active }: { active: boolean }) => active !== false,
  ),
);

const pageSlug = ref(route.value.params.slug);

const navigateToPage = (slug: string) => {
  router.push(slug);
};

return { __sfc: true,props, isDesktop, route, router, sidebarMenu, pageSlug, navigateToPage }
}

})